import React, {useContext} from "react";
import Column from "@amzn/meridian/column";
import PicklistContent from "./PicklistContent";
import PicklistSelector from "./PicklistSelector";
import {RouteDetailContext} from "./context/RouteDetailContext";
import PicklistTabSelector from "./PicklistTabSelector";
import PicklistTabContent from "./PicklistTabContent";
import {CapabilityContext} from "../global/context/CapabilityContext";

const PicklistDetailView = () => {
    const {viewModelRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)
    const isRouteDetailsTabViewEnabled = configViewModel && configViewModel.stationConfig && configViewModel.stationConfig.routeDetailsTabViewEnabled;
    const routeDetailsTabView = (
        <Column>
            <PicklistTabSelector />
            <PicklistTabContent />
        </Column>
    )
    return (viewModelRD.initialised && viewModelRD.picklists.length ?
        <Column>
            {isRouteDetailsTabViewEnabled ? routeDetailsTabView : (
                <Column>
                    <PicklistSelector />
                    {viewModelRD.selectedPicklist ? <PicklistContent /> : null}
                </Column>
            )}
        </Column>
        : null
    )
}

export default PicklistDetailView


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/PicklistDetailView.js